<template>
  <div class="table-setting-menus">
    <!-- icons -->
    <a-tooltip placement="bottom">
      <template v-slot:title>
        <span>템플릿 수정</span>
      </template>
      <FormOutlined
        class="setting-menu-icon"
        @click="() => toggleModal('editVisible')"
      />
    </a-tooltip>
    <a-tooltip v-if="record.isEnable === 1" placement="bottom">
      <template v-slot:title>
        <span>템플릿 삭제</span>
      </template>
      <CloseCircleOutlined
        class="setting-menu-icon"
        @click="() => toggleModal('deleteVisible')"
      />
    </a-tooltip>

    <!-- modals -->
    <TemplateAddEditModal
      v-if="editVisible"
      mode="edit"
      :visible="editVisible"
      :toggleModal="() => toggleModal('editVisible')"
      :templateInfo="record"
    />
    <TemplateDeleteModal
      v-if="deleteVisible"
      :visible="deleteVisible"
      :toggleModal="() => toggleModal('deleteVisible')"
      :templateInfo="record"
    />
  </div>
</template>

<script>
import { computed, reactive, ref, toRefs } from "vue";
import { FormOutlined, CloseCircleOutlined } from "@ant-design/icons-vue";
import TemplateAddEditModal from "@/components/sideComponents/TemplateAddEditModal";
import TemplateDeleteModal from "@/components/sideComponents/TemplateDeleteModal";

export default {
  name: "TemplateSettingMenu",
  props: {
    record: Object,
  },
  components: {
    FormOutlined,
    CloseCircleOutlined,
    TemplateAddEditModal,
    TemplateDeleteModal,
  },
  setup(props) {
    const state = reactive({
      editVisible: false,
      deleteVisible: false,
    });

    const toggleModal = (name) => {
      state[name] = !state[name];
    };

    return {
      ...toRefs(state),
      toggleModal,
    };
  },
};
</script>